import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { Discipline } from '../../../DisciplinesTableContext'
import { HelpMessage } from 'utils/constants'
import { CIMSPage } from '@cims-online/shared'

export function useExpand(): ExpandOptions<Discipline> {
  return {
    expandable: ({ dsToDSDisciplines }) => dsToDSDisciplines.length > 0,
    render: ({ id, dsToDSDisciplines }) => {
      return {
        additionalInfo: [
          {
            label: 'Associated Submittals',
            help: HelpMessage.DesignSubmittals.Disciplines.AssociatedSubmittals,
            type: 'deepLinks',
            showMore: { key: id },
            links: dsToDSDisciplines.map(
              ({ submittal: { id, packageNumber, packageName, deleted } }) => ({
                label: packageNumber,
                tooltip: packageName,
                page: CIMSPage.DSLog,
                deep: {
                  recordId: id,
                  deleted,
                },
              })
            ),
          },
        ],
      }
    },
  }
}
